import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant"],
    _excluded2 = ["selected", "theme", "hoverBg", "disableKb", "onKeyDown", "children"],
    _excluded3 = ["title", "selected", "theme", "hoverBg", "disableKb", "onKeyDown", "children"],
    _excluded4 = ["isFilterItem", "lastItem", "theme"],
    _excluded5 = ["children", "kbDisabled"],
    _excluded6 = ["theme"],
    _excluded7 = ["children", "theme", "isSheetOptions"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext, useState } from 'react';
import { withTheme } from 'styled-components';
import MenuList, { ItemInner, HR, Item as MenuListItem, menuListInnerDefaults, ItemOuter } from '../MenuList';
import Box from '../Box';
import { Text as TextInput } from '../Input';
import { findFocusable } from '../Popover';
import Text from '../Text';
import { CircleChevronIcon } from '../MultiToneIcons';
import { keyLeftEvent, keyRightEvent } from '../utils/kb';
import { FilterCategoriesContainer, FiltersCategory, FiltersPulldown, FiltersSheetTitle } from './SheetFilterMenu';
import SearchAltIcon from '../Icons/SearchAltIcon';
var FilterVariantContext = /*#__PURE__*/React.createContext(null);
export var isMobileVariant = function isMobileVariant(variant) {
  return variant === 'mobile';
};
var FilterMenu = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FilterVariantContext.Provider, {
    value: variant
  }, /*#__PURE__*/React.createElement(Box, _extends({
    display: isMobileVariant(variant) ? 'block' : 'flex',
    py: "15px",
    minHeight: isMobileVariant(variant) ? 'auto' : '350px',
    ref: ref
  }, props)));
});

var focusChild = function focusChild(index) {
  return function (el) {
    if (el && el.children && el.children[index]) {
      var focusable = findFocusable(el.children[index]);

      if (focusable) {
        focusable.focus();
      }
    }
  };
};

var focusFirstChild = focusChild(0);
var focusSecondChild = focusChild(1);
export var FilterItem = withTheme(function (_ref2) {
  var selected = _ref2.selected,
      theme = _ref2.theme,
      hoverBg = _ref2.hoverBg,
      disableKb = _ref2.disableKb,
      _ref2$onKeyDown = _ref2.onKeyDown,
      onKeyDown = _ref2$onKeyDown === void 0 ? function () {} : _ref2$onKeyDown,
      children = _ref2.children,
      innerProps = _objectWithoutProperties(_ref2, _excluded2);

  var outerRef = /*#__PURE__*/React.createRef();
  return /*#__PURE__*/React.createElement(ItemOuter, {
    as: "li",
    role: "menuitem",
    position: "relative",
    ref: outerRef
  }, /*#__PURE__*/React.createElement(ItemInner, _extends({}, menuListInnerDefaults(_objectSpread({
    selected: selected,
    theme: theme,
    hoverBg: hoverBg,
    onKeyDown: onKeyDown,
    outerRef: outerRef,
    disableKb: disableKb
  }, innerProps)), {
    bg: selected ? theme.colors.infoBg : 'transparent',
    pl: theme.menuList.paddingX,
    pr: theme.menuList.paddingX
  }, innerProps), children));
});
process.env.NODE_ENV !== "production" ? FilterItem.propTypes = _objectSpread({}, ItemInner.propTypes) : void 0;

var rotate = function rotate(degrees) {
  return {
    transform: "rotate(".concat(degrees, "deg)"),
    transition: 'transform',
    transitionDuration: '250ms'
  };
};

export var OptionGroup = FilterMenu.OptionGroup = withTheme(function (_ref3) {
  var title = _ref3.title,
      selected = _ref3.selected,
      theme = _ref3.theme,
      hoverBg = _ref3.hoverBg,
      disableKb = _ref3.disableKb,
      _ref3$onKeyDown = _ref3.onKeyDown,
      onKeyDown = _ref3$onKeyDown === void 0 ? function () {} : _ref3$onKeyDown,
      children = _ref3.children,
      innerProps = _objectWithoutProperties(_ref3, _excluded3);

  var _useState = useState(!!selected),
      _useState2 = _slicedToArray(_useState, 2),
      childrenVisible = _useState2[0],
      setVisibility = _useState2[1];

  var outerRef = /*#__PURE__*/React.createRef();
  var variant = useContext(FilterVariantContext);
  return /*#__PURE__*/React.createElement(ItemOuter, {
    as: "li",
    role: "menuitem",
    position: "relative",
    ref: outerRef
  }, /*#__PURE__*/React.createElement(ItemInner, _extends({}, menuListInnerDefaults(_objectSpread({
    selected: selected,
    theme: theme,
    hoverBg: hoverBg,
    disableKb: disableKb,
    onKeyDown: onKeyDown,
    outerRef: outerRef
  }, innerProps)), {
    pl: theme.menuList.paddingX,
    pr: "13px",
    onClick: function onClick() {
      return setVisibility(!childrenVisible);
    },
    color: "label",
    width: "100%",
    minWidth: "unset"
  }, isMobileVariant(variant) ? {
    borderBottom: "1px solid ".concat(theme.colors.keyline),
    pl: 0,
    ml: theme.menuList.paddingX,
    width: "calc(100% - ".concat(theme.menuList.paddingX, ")")
  } : {}, innerProps), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    width: "100%",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    my: "0px",
    title: title,
    textStyle: theme.menuList.textStyle,
    truncate: true
  }, title), /*#__PURE__*/React.createElement(CircleChevronIcon, {
    svgStyle: rotate(childrenVisible ? 90 : 0)
  }))), /*#__PURE__*/React.createElement(MenuList, {
    maxHeight: "unset",
    paddingTop: "0px",
    paddingBottom: "0px",
    display: childrenVisible ? 'block' : 'none'
  }, children));
});
OptionGroup.displayName = 'OptionGroup';

var menuListItemDefaults = function menuListItemDefaults(_ref4) {
  var theme = _ref4.theme,
      variant = _ref4.variant,
      lastItem = _ref4.lastItem;
  return isMobileVariant(variant) ? {
    borderBottom: lastItem ? 'none' : "1px solid ".concat(theme.colors.keyline),
    pl: 0,
    ml: theme.menuList.paddingXSelected,
    width: "calc(100% - ".concat(theme.menuList.paddingXSelected, ")")
  } : {};
};

export var Item = FilterMenu.Item = withTheme(function (_ref5) {
  var isFilterItem = _ref5.isFilterItem,
      lastItem = _ref5.lastItem,
      theme = _ref5.theme,
      props = _objectWithoutProperties(_ref5, _excluded4);

  var variant = useContext(FilterVariantContext);
  return isFilterItem ? /*#__PURE__*/React.createElement(FilterItem, _extends({
    width: "100%"
  }, props)) : /*#__PURE__*/React.createElement(MenuListItem, _extends({
    width: "100%",
    minWidth: "unset"
  }, menuListItemDefaults({
    theme: theme,
    variant: variant
  }), props));
});
FilterMenu.FilterItem = FilterItem;
export var Search = withTheme(function (props) {
  var variant = useContext(FilterVariantContext);
  var mobileVariant = isMobileVariant(variant);
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "li",
    pt: mobileVariant ? "10px" : "0",
    px: "15px",
    pb: "10px",
    bg: mobileVariant ? props.theme.sheet.bg : "bg"
  }, props.boxProps), /*#__PURE__*/React.createElement(TextInput, _extends({
    IconComponent: SearchAltIcon,
    bg: mobileVariant ? "ctrlDisabled" : "bg",
    color: mobileVariant ? "labelCaption" : "label",
    WebkitTextFillColor: mobileVariant ? "labelCaption" : "label",
    textStyle: mobileVariant ? "menuListItem" : props.theme.formField.textStyle,
    clearable: true
  }, props)));
});
FilterMenu.Search = Search;
FilterMenu.HR = HR;
export var Filters = FilterMenu.Filters = withTheme(function (_ref6) {
  var children = _ref6.children,
      _ref6$kbDisabled = _ref6.kbDisabled,
      kbDisabled = _ref6$kbDisabled === void 0 ? false : _ref6$kbDisabled,
      props = _objectWithoutProperties(_ref6, _excluded5);

  var listRef = /*#__PURE__*/React.createRef();
  var variant = useContext(FilterVariantContext);
  var mobileVariant = isMobileVariant(variant);
  return /*#__PURE__*/React.createElement(MenuList, _extends({
    ref: listRef,
    overflow: "auto",
    onKeyDown: function onKeyDown(e) {
      if (isMobileVariant(variant)) return;

      if (!kbDisabled) {
        if (keyRightEvent(e)) {
          focusSecondChild(listRef.current.parentElement);
        }
      }
    }
  }, mobileVariant ? {
    py: 0
  } : {}, {
    width: mobileVariant ? props.theme.filters.sheet.options.width : props.theme.filters.options.width,
    maxHeight: mobileVariant ? props.theme.filters.sheet.maxHeight : props.theme.filters.maxHeight
  }, props), React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      isFilterItem: true
    });
  }));
});
export var OptionsRenderContainer = withTheme(function (_ref7) {
  var theme = _ref7.theme,
      props = _objectWithoutProperties(_ref7, _excluded6);

  var variant = useContext(FilterVariantContext);
  var mobileVariant = isMobileVariant(variant);
  return /*#__PURE__*/React.createElement(Box, _extends({}, !mobileVariant ? {
    borderLeft: "1px solid ".concat(theme.colors.keyline)
  } : {
    marginTop: theme.filters.sheet.options.marginTop
  }, props));
});

var optionsDefaults = function optionsDefaults(_ref8) {
  var theme = _ref8.theme,
      variant = _ref8.variant;
  return _objectSpread({
    bg: 'bg'
  }, isMobileVariant(variant) ? {
    position: 'relative',
    top: '1px',
    py: 0,
    marginTop: theme.filters.sheet.options.marginTop,
    width: theme.filters.sheet.options.width,
    maxHeight: theme.filters.sheet.maxHeight,
    borderTop: "1px solid ".concat(theme.colors.keyline)
  } : {
    width: theme.filters.options.width,
    maxHeight: theme.filters.maxHeight
  });
};

export var Options = FilterMenu.Options = withTheme(function (_ref9) {
  var children = _ref9.children,
      theme = _ref9.theme,
      isSheetOptions = _ref9.isSheetOptions,
      props = _objectWithoutProperties(_ref9, _excluded7);

  var listRef = /*#__PURE__*/React.createRef();
  var variant = useContext(FilterVariantContext);
  var mobileVariant = isMobileVariant(variant);
  return /*#__PURE__*/React.createElement(Box, {
    overflow: "hidden",
    borderLeft: !mobileVariant ? "1px solid ".concat(theme.colors.keyline) : 'none',
    borderBottom: mobileVariant ? "1px solid ".concat(theme.colors.keyline) : 'none'
  }, /*#__PURE__*/React.createElement(MenuList, _extends({
    onKeyDown: function onKeyDown(e) {
      // move to left pane
      if (mobileVariant) return;

      if (keyLeftEvent(e)) {
        focusFirstChild(listRef.current.parentElement);
      }
    },
    ref: listRef
  }, optionsDefaults({
    theme: theme,
    variant: variant
  }), props), React.Children.map(children, function (child, i) {
    return child.type.displayName === 'OptionGroup' && i !== children.length - 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, child, !mobileVariant && /*#__PURE__*/React.createElement(HR, {
      key: "hr -".concat(i)
    })) : child;
  })));
});
export { HR };
FilterMenu.Categories = FilterCategoriesContainer;
FilterMenu.Category = FiltersCategory;
FilterMenu.Pulldown = FiltersPulldown;
FilterMenu.Title = FiltersSheetTitle;
export default FilterMenu;